import React, { useMemo } from 'react'
import { type GridColumns } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import {
  type CollectionDatum,
  type CollectionsRoutingConfig,
} from 'domains/collections/types/collections.types'
import { CollectionsListNameCell } from 'domains/collections/components/collections-list/components/name-cell/CollectionsListNameCell'
import { CollectionsListStatusCell } from 'domains/collections/components/collections-list/components/status-cell/CollectionsListStatusCell'
import { CollectionsListDatesCell } from 'domains/collections/components/collections-list/components/dates-cell/CollectionsListDatesCell'
import { CollectionsListEditCell } from 'domains/collections/components/collections-list/components/edit-cell/CollectionsListEditCell'
import { CollectionsListContentCell } from 'domains/collections/components/collections-list/components/content-cell/CollectionsListContentCell'

interface Props {
  retailerId?: string
  routingConfig: CollectionsRoutingConfig
}

export const useCollectionsListColumns = ({ routingConfig, retailerId }: Props) => {
  const columnHeaders = useDomainMessages({
    name: 'collectionsDomain.list.columns.name.header',
    content: 'collectionsDomain.list.columns.content.header',
    status: 'collectionsDomain.list.columns.status.header',
    activeDates: 'collectionsDomain.list.columns.activeDates.header',
    lastUpdated: 'collectionsDomain.list.columns.lastUpdated.header',
  })

  const columns = useMemo(() => {
    const columns: GridColumns<CollectionDatum> = [
      {
        id: 'name',
        Header: columnHeaders.name,
        Cell: ({ row }) => (
          <CollectionsListNameCell collection={row.original} routingConfig={routingConfig} />
        ),
      },
      {
        id: 'content',
        Header: columnHeaders.content,
        Cell: ({ row }) => <CollectionsListContentCell collection={row.original} />,
      },
      {
        id: 'status',
        Header: columnHeaders.status,
        Cell: ({ row }) => <CollectionsListStatusCell collection={row.original} />,
        width: 100,
      },
      {
        id: 'activeDates',
        Header: columnHeaders.activeDates,
        Cell: ({ row }) => <CollectionsListDatesCell collection={row.original} />,
      },
      // TODO: not returned by backend yet
      // {
      //   id: 'lastUpdated',
      //   Header: columnHeaders.lastUpdated,
      //   Cell: ({ row }) => row.original.lastUpdated,
      // },
      {
        id: 'actions',
        Cell: ({ row }) => (
          <CollectionsListEditCell
            retailerId={retailerId}
            collection={row.original}
            routingConfig={routingConfig}
          />
        ),
        width: 50,
      },
    ]

    return columns
  }, [columnHeaders, routingConfig, retailerId])

  return columns
}
